<sw-page class="riccardo-deal-list">
    <template #smart-bar-header>
        <h2>{{ $t('riccardo-deal.list.title') }} <span v-if="!isLoading">({{ total }})</span></h2>
    </template>

    <template #smart-bar-actions>
        <sw-button variant="primary" :router-link="{ name: 'riccardo.deal.create' }">
            {{ $t('riccardo-deal.list.buttonCreate') }}
        </sw-button>
    </template>

    <template #content>
        <sw-entity-listing
            v-if="deals"
            :items="deals"
            :repository="dealRepository"
            :columns="columns"
            :is-loading="isLoading"
            :show-selection="false"
            detail-route="riccardo.deal.detail"
            @update-records="getList"
        >
            <template #column-active="{ item }">
                <sw-icon :name="item.active ? 'regular-checkmark-xs' : 'regular-times-s'" :color="item.active ? '#37d046' : '#de294c'" small />
            </template>
            <template #column-priceValue="{ item }">{{ formatPrice(item) }}</template>
            <template #column-minQualifyingValue="{ item }">{{ formatCondition(item) }}</template>
            <template #column-behavior="{ item }">{{ $t('riccardo-deal.detail.behavior_' + item.behavior) }}</template>
            <template #column-validUntil="{ item }">{{ item.validUntil ? new Date(item.validUntil).toLocaleString('de-DE') : '–' }}</template>
        </sw-entity-listing>

        <sw-empty-state v-else-if="!isLoading" :title="$t('riccardo-deal.list.empty')" icon="regular-tag" />
    </template>
</sw-page>
